module.exports = __webpack_public_path__ + "static/barak_mark-04e3111dd7c22b30998464f004e496c9.jpg";